<template>
  <div class="row">
    <div class="col-12">
      <div class= "small-chart">
        <p class="text-center">
          <label for="weekPicker">Select Week No. </label>
          <VueDatePicker name="weekPicker" v-model="selectedWeek" type="week" placeholder="Week" valueType="format" :showWeekNumber="true" :firstDayOfWeek="1"></VueDatePicker>
        </p>
        <br/>

        <template v-if="dataLoaded">
          <BarChart
            v-if="dataLoaded"
            :chart-data="baseChartData"
            :options="options"
            :height="400">
          </BarChart>
          <!-- <LineChart
            v-if="dataLoaded"
            :chart-data="baseChartData"
            :options="options"
            :height="400">
          </LineChart> -->
        </template>
        <template v-else>
          <p class="text-center">
            <small class="text-muted">Please select the Week No. from the dropdown above to view the sensor data detection of the week.</small>
          </p>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
/*eslint-disable*/
// import LineChart from "./Charts/LineChart.vue"
import BarChart from "./Charts/BarChart.vue"
import {baseApiUrl} from "../../config.js"
import axios from "axios"
import VueDatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
  name:"SensorHistoryChart",
  components: {
    // LineChart,
    BarChart,
    VueDatePicker
  },
  props: {
    inputYear: String,
    inputSensorCode: String
  },
  data(){
    return {
      dataLoaded: false,
      selectedWeek: 1,
      selectedWeekflat: "",
      baseChartData: {
        datasets: [
            {
              label: 'Status',
              backgroundColor: '#9276bc',
              data: [1,0,0,1,1,0,0],
              fill: true,
              borderColor: '#9276bc'
            },
            // {
            //   label: 'Sample',
            //   backgroundColor: '#1d566c',
            //   data: [0,1,1,0,0,1],
            //   fill: false,
            //   borderColor: '#1d566c'
            // }
        ],
        labels: [
          "Mon",
          "Tue",
          "Wed",
          "Thu",
          "Fri",
          "Sat",
          "Sun"
        ],
      },
      options: {
        scales: {
          yAxes: [
            {
              display: true,
              ticks: {
                beginAtZero: true,
                // min: -1,
                stepSize: 1
              },
              stacked: true
            }
          ],
          xAxes: [
            {
              stacked: true
            }
          ]
        },
        title: {
          text: "Sensor Data Weekly Detection",
          display: true,
          // fontFamily: "Comfortaa",
          fontSize: 20
        },
        responsive: true,
        maintainAspectRatio: false
      },
    }
  },
  watch: {
    selectedWeek: function() {
      const current = this
      // console.log(current.selectedWeek)
      current.dataLoaded = false;
      current.getChartData(current.inputSensorCode)
      // console.log(current.baseChartData.datasets);
    }
  },
  methods: {
    getChartData: function(sensorCode) {
      const current = this;
      var url = baseApiUrl + "getChartData"
      var config = {
        responseType: 'json',
        params: {
          sensorId: sensorCode,
          week: current.selectedWeek,
          year: 2020
        }
      }
      axios.get(url, config).then(function(result) {
        // console.log(result.data);
        var weekDays = result.data.weekDays
        var sensorData = result.data.sensorData
        var dataSet = current.baseChartData.datasets[0]
        dataSet.data = []
        Object.keys(weekDays).forEach(function(key) {
          var dataValue = 0
          sensorData.forEach((sensorItem, index) => {
            let sensorDate = new Date(sensorItem.sensorLogTime)
            let year = sensorDate.getFullYear().toString();
            let month = sensorDate.getMonth() + 1;
            month = month.toString().padStart(2, '0');
            let day = sensorDate.getDate().toString().padStart(2, '0');
            let sensorDateFormat = year + '-' + month + '-' + day

            if(sensorDateFormat == weekDays[key]){
              dataValue = 1
            }
          });
          dataSet.data.push(dataValue)

        });

        current.dataLoaded = true;

      }).catch((error)=> {
        console.log(error);
      });
    }
  },
  // mounted() {
  //   const current = this
  //   console.log("test mount");
  // }

}
</script>

<style>
  .small-chart {
    /* max-width: 340px; */
    max-width: 22vw !important;
    margin:  5px auto;
    /* height: '500px';
    width: '100%';
    position: 'relative'; */
  }
</style>
